import React, { useContext, useState } from 'react'
import { Button, Col, Divider, Row, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import useHideMenu from '../hooks/useHideMenu'
import { Navigate, useNavigate } from 'react-router-dom'
import { getUserStorage } from '../helpers/getUserStorage'
import { SocketContext } from '../context/SocketContext'

const { Title, Text } = Typography

const Desktop = () => {
    const [user] = useState(getUserStorage())
    const [ticket, setTicket] = useState(null)
    const { socket } = useContext(SocketContext)
    const navigate = useNavigate()

    useHideMenu(false)

    const exit = () => {
        localStorage.removeItem('agentUser')
        navigate('/login')
    }

    const nextTicket = () => {
        socket.emit('next-ticket', user, (ticket) => {
            setTicket(ticket)
        })
    }

    if (!user) return <Navigate to="/login" />

    return (
        <>
            <Row>
                <Col span={20}>
                    <Title level={2}>{user.agent}</Title>
                    <Text className="text3">You're working on desk: </Text>
                    <Text className="text3" type="success"><b>{user.desk}</b></Text>
                </Col>

                <Col span={4} align="right">
                    <Button
                        type="danger"
                        shape="round"
                        onClick={exit}
                    >
                        <CloseCircleOutlined />
                        Exit
                    </Button>
                </Col>
            </Row>

            <Divider />

            <Row>
                {ticket && (
                    <Col>
                        <Text className="text3">You're assinting ticket number: </Text>
                        <br />
                        <Text
                            style={{
                                'width': '100%',
                                'display': 'block',
                                'fontSize': 28,
                                'textAlign': 'center'
                            }}
                            type="danger"
                            align="right"
                        >
                            <b>{ticket.number}</b>
                        </Text>
                    </Col>
                )}

                <Col span={4} offset={20} align="right">
                    <Button
                        type="primary"
                        shape="round"
                        onClick={nextTicket}
                    >
                        Next ticket
                    </Button>
                </Col>
            </Row>
        </>
    )
}

export default Desktop